import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const MenuFilters = ({ 
  searchQuery, 
  setSearchQuery, 
  selectedCategory, 
  setSelectedCategory,
  selectedDietary,
  setSelectedDietary,
  selectedSpiceLevel,
  setSelectedSpiceLevel,
  onClearFilters
}) => {
  const categoryOptions = [
    { value: 'all', label: 'All Items' },
    { value: 'tacos', label: 'Tacos' },
    { value: 'burritos', label: 'Burritos' },
    { value: 'quesadillas', label: 'Quesadillas' },
    { value: 'nachos', label: 'Nachos & Sides' },
    { value: 'drinks', label: 'Drinks' },
    { value: 'desserts', label: 'Desserts' }
  ];

  const dietaryOptions = [
    { value: 'all', label: 'All Dietary' },
    { value: 'vegetarian', label: 'Vegetarian' },
    { value: 'vegan', label: 'Vegan' },
    { value: 'gluten-free', label: 'Gluten Free' }
  ];

  const spiceLevelOptions = [
    { value: 'all', label: 'All Spice Levels' },
    { value: 'mild', label: 'Mild 🌶️' },
    { value: 'medium', label: 'Medium 🌶️🌶️' },
    { value: 'hot', label: 'Hot 🌶️🌶️🌶️' },
    { value: 'extra-hot', label: 'Extra Hot 🌶️🌶️🌶️🌶️' }
  ];

  const hasActiveFilters = searchQuery || selectedCategory !== 'all' || selectedDietary !== 'all' || selectedSpiceLevel !== 'all';

  return (
    <div className="bg-[var(--color-card)] border border-[var(--color-border)] rounded-xl p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-2">
          <Icon name="Filter" size={20} color="var(--color-primary)" />
          <h3 className="text-lg font-semibold text-[var(--color-foreground)]">Filter Menu</h3>
        </div>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            iconPosition="left"
            onClick={onClearFilters}
          >
            Clear All
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Input
          type="search"
          placeholder="Search menu items..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e?.target?.value)}
          className="w-full"
        />

        <Select
          options={categoryOptions}
          value={selectedCategory}
          onChange={setSelectedCategory}
          placeholder="Select category"
        />

        <Select
          options={dietaryOptions}
          value={selectedDietary}
          onChange={setSelectedDietary}
          placeholder="Dietary preferences"
        />

        <Select
          options={spiceLevelOptions}
          value={selectedSpiceLevel}
          onChange={setSelectedSpiceLevel}
          placeholder="Spice level"
        />
      </div>
      <div className="mt-4 flex flex-wrap gap-2">
        <div className="flex items-center gap-2 px-3 py-1 bg-[var(--color-success)]/10 rounded-full">
          <Icon name="CheckCircle" size={14} color="var(--color-success)" />
          <span className="text-xs font-medium text-[var(--color-success)]">100% Halal</span>
        </div>
        <div className="flex items-center gap-2 px-3 py-1 bg-[var(--color-primary)]/10 rounded-full">
          <Icon name="Leaf" size={14} color="var(--color-primary)" />
          <span className="text-xs font-medium text-[var(--color-primary)]">Fresh Ingredients</span>
        </div>
        <div className="flex items-center gap-2 px-3 py-1 bg-[var(--color-accent)]/10 rounded-full">
          <Icon name="Clock" size={14} color="var(--color-accent)" />
          <span className="text-xs font-medium text-[var(--color-accent)]">Made to Order</span>
        </div>
      </div>
    </div>
  );
};

export default MenuFilters;